import React from 'react';

const HomePage = () => {
  return (
    <div className="page">
      <div className="container">
        <section className="hero">
          <h1 className="name">Nandaluru</h1>
          <h2 className="name">Mohan Reddy</h2>
          <p className="mt-8 max-w-2xl opacity-90">
            Passionate developer specializing in secure and scalable web
            solutions. Focused on creating robust systems with cutting-edge
            technology.
          </p>
        </section>
      </div>
    </div>
  );
};

export default HomePage; 